import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import PayRoute from './routes/pay';
import './App.css';

function Home() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#000000ff',
      overflow: 'hidden'
    }}>
      <div style={{
        textAlign: 'center',
        padding: '40px',
        opacity: isLoaded ? 1 : 0,
        transform: isLoaded ? 'translateY(0) scale(1)' : 'translateY(50px) scale(0.9)',
        transition: 'all 1s cubic-bezier(0.34, 1.56, 0.64, 1)'
      }}>
        <div style={{
          marginBottom: '40px',
          opacity: isLoaded ? 1 : 0,
          transform: isLoaded ? 'scale(1)' : 'scale(0.5)',
          transition: 'all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s'
        }}>
          <img
            src="/trappay_logo.png"
            alt="TrapPay"
            style={{
              height: '120px',
              width: 'auto',
              filter: 'drop-shadow(0 10px 30px rgba(34, 197, 94, 0.4))',
              animation: isLoaded ? 'float 3s ease-in-out infinite' : 'none'
            }}
          />
        </div>

        <h1 style={{
          color: 'white',
          fontSize: '48px',
          fontWeight: 'bold',
          marginBottom: '20px',
          opacity: isLoaded ? 1 : 0,
          transform: isLoaded ? 'translateY(0)' : 'translateY(20px)',
          transition: 'all 0.8s ease 0.4s'
        }}>
          Secure Payment Processing
        </h1>

        <p style={{
          color: '#94a3b8',
          fontSize: '18px',
          marginBottom: '40px',
          opacity: isLoaded ? 1 : 0,
          transform: isLoaded ? 'translateY(0)' : 'translateY(20px)',
          transition: 'all 0.8s ease 0.6s'
        }}>
          Fast, simple, and secure payments
        </p>

        <a
          href="/pay"
          style={{
            display: 'inline-block',
            padding: '16px 48px',
            backgroundColor: '#16a34a',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '12px',
            fontSize: '18px',
            fontWeight: 'bold',
            border: '2px solid #22c55e',
            opacity: isLoaded ? 1 : 0,
            transform: isLoaded ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.9)',
            transition: 'all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.8s',
            boxShadow: '0 10px 30px rgba(22, 163, 74, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#15803d';
            e.target.style.transform = 'translateY(-2px) scale(1.05)';
            e.target.style.boxShadow = '0 15px 40px rgba(22, 163, 74, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#16a34a';
            e.target.style.transform = 'translateY(0) scale(1)';
            e.target.style.boxShadow = '0 10px 30px rgba(22, 163, 74, 0.3)';
          }}
        >
          Start Payment
        </a>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pay" element={<PayRoute />} />
      </Routes>
    </Router>
  );
}

export default App;
